// You can write more code here

import { CheckboxController } from '@/game/GameComponents/PhaserGame/UI/CheckboxController';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Checkbox extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    this.scaleX = 4;
    this.scaleY = 4;

    // checkboxBacking
    const checkboxBacking = scene.add.image(0, 0, 'check6_on');
    this.add(checkboxBacking);

    this.checkboxBacking = checkboxBacking;

    /* START-USER-CTR-CODE */
    this.brain = new CheckboxController(this);
    /* END-USER-CTR-CODE */
  }

  public checkboxBacking: Phaser.GameObjects.Image;
  public IsInteractive: boolean = true;

  /* START-USER-CODE */

  public brain: CheckboxController;
  public onTexture: string = 'check6_on';
  public offTexture: string = 'check6_off';
  public disabledOffTexture: string = 'check disabled 01';
  public disabledOnTexture: string = 'check disabled 01';
  public hoverOnTexture: string = 'check hover on';
  public hoverOffTexture: string = 'check hover 04';

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
